<script context="module">
    import { env } from '../Environment.svelte';
    function processOffers(offersData) {
        if (!offersData || !offersData.offers) return;
        const extrasMapNames = [
            'facturacion',
            'graba',
            'movil2_0',
            'canalesPremium',
            'extensiones',
            'telefonoExtensiones',
            'telefono',
            'internet',
            'canalesCarta',
            'ott',
        ];
        makeExtra(offersData);

        Object.values(offersData.offers).forEach((offer) => {
            offer.forEach((packet) => {
                if (packet.extrasMap) {
                    Object.entries(packet.extrasMap).forEach(
                        ([extraType, extras]) => {
                            packet.extrasMap[extraType] = extras.map(
                                (extraIdReference) =>
                                    offersData.extras[extraIdReference]
                            );
                        }
                    );
                    extrasMapNames.forEach((extraName) => {
                        if (!packet.extrasMap[extraName]) {
                            packet.extrasMap[extraName] = [];
                        }
                    });
                }
            });
        });
    }

    function makeExtra(coverage) {
        coverage.extras = Object.fromEntries(
            Object.entries(coverage.extras).map(([key, extra]) => [
                key,
                {
                    extId: extra.extId,
                    paqextMaximo: extra.paqextMaximo,
                    paqextOrden: extra.paqextOrden,
                    paqextQuitar: extra.paqextQuitar,
                    paqextVisible: extra.paqextVisible,
                    paqextDefault: extra.paqextDefault,
                    paquetesVisible: extra.paquetesVisible,
                    extra: {
                        cost: extra.cost,
                        promoCost: extra.promoCost,
                        precioSP: extra.precioSP,
                        promoCostViX: extra.promoCostViX,
                        extEliminar:
                            extra.extEliminar && extra.extEliminar.length > 0
                                ? extra.extEliminar
                                : null,
                        extRequired:
                            extra.extRequired && extra.extRequired.length > 0
                                ? extra.extRequired
                                : null,
                        extGrupo: extra.extGrupo ? extra.extGrupo : null,
                        subtitle: extra.description,
                        title: extra.title,
                        extName: extra.extName,
                        promoItem: extra.promoItem ? extra.promoItem : null,
                        opcionesModular: extra.opcionesModular,
                        descriptionOTT: extra.descriptionOTT,
                    },
                },
            ])
        );
    }

    function proxyOffer(offerData) {
        if (!offerData) {
            return;
        }
        const offnetOffers = offerData[0];
        const onnetOffers = offerData[1];
        processOffers(onnetOffers);
        processOffers(offnetOffers);
        //load to store
        const loadedOffer = {
            coverageType:
                onnetOffers?.coverageType || offnetOffers.coverageType,
            offers: {
                tripleplay_modular: onnetOffers
                    ? onnetOffers.offers.tripleplay_modular
                    : null,
                residencial_modular: onnetOffers
                    ? onnetOffers.offers.residencial_modular
                    : null,
                tv_modular: onnetOffers ? onnetOffers.offers.tv_modular : null,
                izzimovil_modular: onnetOffers
                    ? onnetOffers.offers.izzimovil_modular
                    : null,
                izzinegocios: onnetOffers
                    ? onnetOffers.offers.izzinegocios
                    : null,
                izzinegocios_3P: onnetOffers
                    ? onnetOffers.offers.izzinegocios_3P
                    : null,
                offnet_izzi: offnetOffers
                    ? offnetOffers.offers.offnet_izzi
                    : null,
                offnet_sky: offnetOffers
                    ? offnetOffers.offers.offnet_sky
                    : null,
                offnet_izzi_movil: offnetOffers
                    ? offnetOffers.offers.offnet_izzi_movil
                    : null,
            },
            rptCode: onnetOffers?.rptCode
                ? onnetOffers.rptCode
                : offnetOffers.rptCode,
        };
        return loadedOffer;
    }

    export async function getOfferV2(
        postalCode,
        latitude,
        longitude,
        offnetCoverage,
        offnetIzziCoverage
    ) {
        const headers = new Headers();
        headers.append('x-api-key', env?.[env?.stage]?.api?.key);
        headers.append('Content-Type', 'application/json');

        const body = JSON.stringify({
            postalCode: postalCode,
            latitude: latitude.toString(),
            longitude: longitude.toString(),
        });
        const validateOffer = await fetch(
            env[env.stage].api.url +
                'apikey/izzi/ms/purchaseServices/serviceability/validateOffer',
            {
                method: 'POST',
                headers: headers,
                body: body,
            }
        );

        if (!validateOffer.ok) {
            throw new Error(
                `Error: ${validateOffer.status} ${validateOffer.statusText}`
            );
        }

        const requests = [
            fetch(
                env[env.stage].api.url +
                    'apikey/izzi/ms/purchaseServices/sales/offersByCP',
                {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({
                        postalCode,
                        offnet: offnetCoverage,
                        latitude,
                        longitude,
                    }),
                }
            ),
        ];

        if (!offnetCoverage) {
            requests.push(
                fetch(
                    env[env.stage].api.url +
                        'apikey/izzi/ms/purchaseServices/sales/offersByCP',
                    {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            postalCode,
                            offnet: offnetCoverage,
                            latitude,
                            longitude,
                        }),
                    }
                )
            );
        }

        const fetchOffer = await Promise.all(requests);

        // check if any of the requests failed
        const failedRequests = fetchOffer.filter((res) => !res.ok);
        if (failedRequests.length > 0) {
            throw new Error('Error fetching offers');
        }

        const offerData = await Promise.all(
            fetchOffer.map((res) => res.json())
        );
        const proxyOfferData = proxyOffer(offerData);
        return proxyOfferData;
    }
</script>
